import React from "react";

export default function Performance() {
  return (
    <div className="page">
      <h1>Performance Review System</h1>
      <p>Performance system placeholder.</p>
    </div>
  );
}
